import React from 'react';
import { useSelector } from 'react-redux';
import { MotionLink } from 'features/motion-router';

import styles from './LunchPageFilterBadge.module.scss';
import { getFilteredRestaurants } from 'store/restaurants/selectors';
import { getRestaurantData } from 'store/data/selectors';
import { useTranslation } from 'features/translator';
import { ReactComponent as RestaurantFilterIcon } from './assets/restaurant-filter.svg';

const RestaurantFilterBadge: React.FunctionComponent = () => {
  const filteredIds = useSelector(getFilteredRestaurants);
  const allRestaurants = useSelector(getRestaurantData);
  const translation = useTranslation();

  console.log('Filtered restaurants in RestaurantFilterBadges:', filteredIds);

  const filteredRestaurants = allRestaurants.filter((r) => filteredIds.includes(r.id));

  return (
    <MotionLink to="/asetukset/ravintolat" className={styles.component}>
      <span className={styles.dietsButton}>
        <RestaurantFilterIcon className={styles.buttonIcon} />
        {translation.get('restaurantsPage', 'restaurants')}

        {filteredRestaurants.length > 0 && (
          <span className={styles.count}>{filteredRestaurants.length}</span>
        )}
      </span>
    </MotionLink>
  );
};

export default RestaurantFilterBadge;
